/**
 * @generated SignedSource<<b04b55d5694749c4907ec1b426128e26>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SaveAdditionalAttributeInput = {
  additionalAttributeID?: string | null;
  data?: string | null;
  name?: string | null;
  productIDs?: ReadonlyArray<string> | null;
  status: number;
};
export type addExtraOptionPanel_AssignMutation$variables = {
  input: SaveAdditionalAttributeInput;
};
export type addExtraOptionPanel_AssignMutation$data = {
  readonly saveAdditionalAttribute: {
    readonly additionalAttributeID: number;
    readonly id: string;
  };
};
export type addExtraOptionPanel_AssignMutation = {
  response: addExtraOptionPanel_AssignMutation$data;
  variables: addExtraOptionPanel_AssignMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AdditionalAttribute",
    "kind": "LinkedField",
    "name": "saveAdditionalAttribute",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "additionalAttributeID",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "addExtraOptionPanel_AssignMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "addExtraOptionPanel_AssignMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d107e03f80a1ceb50491fa7b33bd6415",
    "id": null,
    "metadata": {},
    "name": "addExtraOptionPanel_AssignMutation",
    "operationKind": "mutation",
    "text": "mutation addExtraOptionPanel_AssignMutation(\n  $input: SaveAdditionalAttributeInput!\n) {\n  saveAdditionalAttribute(input: $input) {\n    id\n    additionalAttributeID\n  }\n}\n"
  }
};
})();

(node as any).hash = "0251a3aec2052ede4f53e5caab0319ee";

export default node;
